"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateCarriers {
}
exports.TemplateCarriers = TemplateCarriers;
//# sourceMappingURL=TemplateCarriers.js.map